/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import * as actionsHeader from "../../Components/Header/action";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button, Select, Input, Typography } from "antd";
import * as actions from "../PainelAtividades/FiltroMeusPacientes/action";
import MeusPacientesTabela from "./Components/MeusPacientesTabela";
import { maskCPF } from "Misc/utils";
import { PERFIS } from "Misc/constants";
import "./style.scss";

const MeusPacientes = ({
  getPatient,
  pacientesPlano,
  resetFilterPlan,
  loading,
  user,
  changeCabecalhoInfo,
}) => {
  const InputGroup = Input.Group;
  const { Option } = Select;
  const { Search } = Input;
  const { Text } = Typography;
  const [seletor, setSeletor] = useState("nome");
  const [cpf, setCpf] = useState("");

  const navigate = useNavigate();

  const handleClick = async (value, seletor) => {
    resetFilterPlan();

    const body = { token: "gecro" };
    const nameAttribute = "nome";
    const cpfAttribute = "cpf";
    const attendAttribute = "atendente";

    switch (seletor) {
      case "nome":
        body[nameAttribute] = value;
        break;
      case "cpf":
        body[cpfAttribute] = value;
        break;
      default:
        body[attendAttribute] = user.id;
    }

    if (Boolean(value)) {
      await getPatient(JSON.stringify(body));
    }
  };

  useEffect(() => {
    changeCabecalhoInfo({
      nome: "Plano de Cuidados",
    });

    return () => {
      resetFilterPlan();
    };
  }, []);

  return (
    <>
      <div className="layoutFilterTop">
        {user.perfil === PERFIS.ENFERMEIRO_UBS && (
          <>
            <Button
              type="primary"
              className="layoutTopButton"
              onClick={handleClick}
              loading={loading}
            >
              Meus pacientes
            </Button>
            <Text style={{ whiteSpace: 'nowrap', flexShrink: 0, padding: '0 8px' }}> ou </Text>
          </>
        )}

        <InputGroup compact>
          <Select value={seletor} style={{ width: 85 }} onChange={setSeletor}>
            <Option value="nome">Nome</Option>
            <Option value="cpf">CPF</Option>
          </Select>
          {seletor === "nome" ? (
            <Search
              loading={loading}
              onSearch={(value) => handleClick(value, seletor)}
              style={{ width: 190 }}
              allowClear
            />
          ) : (
            <Search
              className="layoutForm"
              value={cpf}
              onChange={(e) => setCpf(maskCPF(e.target.value))}
              loading={loading}
              onSearch={() => handleClick(cpf, seletor)}
              style={{ width: 190 }}
              maxLength={14}
              allowClear
            />
          )}
        </InputGroup>
        <Button
          type="primary"
          onClick={() => navigate(-1)}
          style={{fontWeight: 'bold'}}
        >
          Voltar
        </Button>
      </div>
      <div className="layoutTable">
        {pacientesPlano != null && <MeusPacientesTabela />}
      </div>
    </>
  );
};

const mapStateToProps = (store) => ({
  pacientesPlano: store.meuspacientes.pacientesPlano,
  loading: store.meuspacientes.loading,
  user: store.login.user,
});

const mapDispatchToProps = (dispatch) => ({
  changeCabecalhoInfo: (info) =>
    dispatch(actionsHeader.changeCabecalhoInfo(info)),
  getPatient: (mock) => dispatch(actions.getPatient(mock)),
  resetFilterPlan: () => dispatch(actions.resetFilterPlan()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MeusPacientes);
